module.exports = __webpack_public_path__ + "img/svg.631b8f85.svg";